.mat-mdc-form-field{--mat-mdc-form-field-floating-label-scale: .75;display:block;flex-direction:column;min-width:0;text-align:left}
/*# sourceMappingURL=user-forgot-password.component-BQ7GTDFS.css.map */
